import { HTTP } from './helpers/http.js'
import qs from 'qs'

export default {
  getById(organizationId) {
    const url = `/api/v1/organizations/${organizationId}`
    return HTTP.get(url)
  },

  getAll(query) {
    const params = {
      params: query,
      paramsSerializer: function(params) {
        return qs.stringify(params, { arrayFormat: 'brackets' })
      },
    }

    const url = '/api/v1/organizations'
    return HTTP.get(url, params)
  },

  create(data) {
    const url = '/api/v1/organizations'
    return HTTP.post(url, data)
  },

  update(organizationId, data) {
    const url = `/api/v1/organizations/${organizationId}`
    return HTTP.put(url, data)
  },

  updateSettings(organizationId, data) {
    const url = `/api/v1/organizations/${organizationId}/settings`
    return HTTP.put(url, data)
  },

  createAccount(organizationId, data) {
    const url = `/api/v1/organizations/${organizationId}/accounts`
    return HTTP.post(url, data)
  },

  getOrganizationStructure(organizationId) {
    const url = `/api/v1/organizations/${organizationId}/structure`
    return HTTP.get(url)
  },

  getOrganizationSites(organizationId, query) {
    const params = {
      params: query,
      paramsSerializer: function(params) {
        return qs.stringify(params, { arrayFormat: 'brackets' })
      },
    }
    const url = `/api/v1/organizations/${organizationId}/sites`
    return HTTP.get(url, params)
  },
}
